type Props = {
  brand: string;
  tagline: string;
  regions: string[];
  packageName: string;
  kind: 'sponsor' | 'tournament';
};

export default function PlacementPreview({ brand, tagline, regions, packageName, kind }: Props) {
  const displayBrand = brand.trim() || 'Your business name';
  const displayTagline = tagline.trim() || 'Your short message to local golfers';

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="px-5 py-3.5 border-b border-background-200 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center text-lg"><i className="ri-layout-4-line"></i></span>
          <h3 className="font-heading font-bold text-xl text-foreground-950">Placement preview</h3>
        </div>
        <span className="bg-secondary-100 text-secondary-900 border border-secondary-200 font-label font-bold uppercase tracking-widest text-[10px] px-2.5 py-1 rounded-sm whitespace-nowrap">
          Illustration
        </span>
      </div>

      <div className="p-4 md:p-5">
        {/* Mock website surface */}
        <div className="rounded-lg border border-background-300 overflow-hidden bg-background-50">
          <div className="bg-foreground-950 px-4 py-2.5 flex items-center justify-between">
            <span className="font-heading font-extrabold uppercase tracking-wide text-background-50 text-sm">GreenSide News</span>
            <span className="font-label uppercase tracking-widest text-[9px] text-background-300">Sample placement</span>
          </div>

          {kind === 'sponsor' ? (
            <div className="p-4">
              <div className="rounded-md border border-primary-200 bg-primary-50 px-4 py-4 flex flex-wrap items-center gap-4">
                <span className="w-12 h-12 rounded-md bg-foreground-950 text-accent-400 flex items-center justify-center font-heading font-extrabold text-xl shrink-0">
                  {displayBrand.charAt(0).toUpperCase()}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="font-heading font-bold text-lg text-foreground-950 truncate">{displayBrand}</p>
                  <p className="text-xs text-foreground-600 truncate">{displayTagline}</p>
                </div>
                <span className="font-label font-bold uppercase tracking-widest text-[10px] bg-primary-500 text-background-50 px-3 py-2 rounded-md whitespace-nowrap">Sponsored</span>
              </div>
              <div className="mt-3 grid grid-cols-2 gap-3">
                <div className="h-16 rounded-md bg-background-100 border border-background-200"></div>
                <div className="h-16 rounded-md bg-background-100 border border-background-200"></div>
              </div>
              <p className="mt-3 font-label uppercase tracking-widest text-[10px] text-foreground-500">{packageName} · homepage sponsor strip</p>
            </div>
          ) : (
            <div className="p-4">
              <div className="rounded-md border border-accent-300 bg-accent-50 px-4 py-4">
                <span className="inline-flex items-center gap-1.5 font-label font-bold uppercase tracking-widest text-[9px] bg-accent-500 text-foreground-950 px-2 py-1 rounded-sm mb-2">
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-star-line"></i></span>
                  Featured tournament
                </span>
                <p className="font-heading font-bold text-lg text-foreground-950">{displayBrand}</p>
                <p className="text-xs text-foreground-600 mt-1">{displayTagline}</p>
              </div>
              <div className="mt-3 space-y-2">
                <div className="h-3 rounded-full bg-background-200 w-3/4"></div>
                <div className="h-3 rounded-full bg-background-200 w-1/2"></div>
              </div>
              <p className="mt-3 font-label uppercase tracking-widest text-[10px] text-foreground-500">{packageName} · tournament calendar</p>
            </div>
          )}
        </div>

        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="font-label uppercase tracking-widest text-[10px] text-foreground-500">Shown in</span>
          {regions.length === 0 ? (
            <span className="text-xs text-foreground-500">No regions selected yet</span>
          ) : (
            regions.map((r) => (
              <span key={r} className="bg-primary-100 text-primary-700 border border-primary-200 font-label font-semibold uppercase tracking-wide text-[10px] px-2.5 py-1 rounded-full whitespace-nowrap">{r}</span>
            ))
          )}
        </div>
      </div>
    </div>
  );
}